export default "__VITE_ASSET__DdjBpCMx__"